import React from 'react';
import EodData from "../components/eod/EodData";

const Eod = () =>{
    return (
        <div>
            <EodData/>
        </div>
    )
}

export default Eod;